/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAwsEdpConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAwsEdpConfiguration");
    }

    getFixupPrototypeFunction() { return CostAwsEdpConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAwsEdpConfiguration>): CostAwsEdpConfiguration {
        let obj = Object.assign(new CostAwsEdpConfiguration(), model);
        CostAwsEdpConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAwsEdpConfiguration>): CostAwsEdpConfiguration {
        if (!model) return null;
        return CostAwsEdpConfiguration.newInstance(<CostAwsEdpConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAwsEdpConfiguration) {
        if (!obj) return;

        models.CostAwsEdpConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAwsEdpConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAwsEdpConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
